import { http } from "../api/http";
import Utils from "../utils";

export const emailDomainAuthenticatorService = {
  checkDomain,
  getById,
  get,
  create,
  remove,
  update,
};

async function checkDomain(requestParameters) {
  let url = `/auth/check-domain?${Utils.objectToQueryString(
    requestParameters
  )}`;

  const response = await http.get(url);
  return response;
}

async function getById(requestParameters) {
  let url = `/auth/byid?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function get(requestParameters) {
  let url = `/auth?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.get(url);
  return response;
}

async function create(requestBody) {
  let url = `/auth/create`;

  const response = await http.post(url, JSON.stringify(requestBody));
  return response;
}

async function remove(requestParameters) {
  let url = `/auth/delete?${Utils.objectToQueryString(requestParameters)}`;

  const response = await http.delete(url);
  return response;
}

async function update(requestBody) {
  let url = `/auth/update`;

  const response = await http.put(url, JSON.stringify(requestBody));
  return response;
}
